<div class="task-request-section">
  <div class="body">
    <app-sidenav-header title="Solicitação de tarefa" (closeEvent)="close()"></app-sidenav-header>

    <form [formGroup]="relocateForm">
      <div class="card-header">Configurar nova tarefa de realocação</div>
      <div class="card-body">
        <mat-tab-group class="inventory-tabs" (selectedTabChange)="changePickingType($event)">
          <mat-tab label="Produto Único"></mat-tab>
          <mat-tab label="Multi Produtos"></mat-tab>
        </mat-tab-group>
        <div class="banner warning-background" *ngIf="isMultiProduct">
          As funções de reabastecimento, mínimo e máximo de produtos não estão disponíveis na função Multi Produtos.
        </div>
        <div class="product-input">
          <p>Digite o que deseja realocar:</p>
          <mat-form-field>
            <input matInput
                   placeholder="Código do produto ou a descrição do produto"
                   formControlName="productSku"
                   [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayedString">
              <mat-option *ngFor="let product of productOptions" [value]="product">{{ product.name + ' - ' + product.sku }}</mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="pallet-input">
          <mat-form-field class="pallets">
            <mat-label>Selecione o pallet desejado</mat-label>
            <mat-select formControlName="pallet" placeholder="Selecione o pallet desejado"
              [disabled]="!relocateForm.controls.productSku.value">
              <mat-select-trigger>
                <div class="pallet-option-selected" *ngIf="relocateForm.controls.pallet.value">
                  Posição: {{ handlePosition(relocateForm.controls.pallet.value) }}, qtd: {{ handleQuantity(relocateForm.controls.pallet.value?.skuGroups) }}
                </div>
              </mat-select-trigger>
              <mat-option *ngFor="let pallet of palletsOptions" [value]="pallet"
                [disabled]="pallet.skuGroups?.length > 1 && isSingleProduct">
                <div class="pallet-option">
                  <span class="pallet-desc">
                    Posição: {{ handlePosition(pallet) }}, qtd: {{ handleQuantity(pallet?.skuGroups) }}
                  </span>
                  <span *ngIf="pallet.skuGroups?.length > 1" class="pallet-multi">Pallet multireferência</span>
                </div>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        
        <div class="pallets-content-row" *ngIf="relocateForm.controls.pallet.value">
          <div class="pallet-content-list-wrapper" [class.full-width]="isMultiProduct">
            <label for="pallet-content-list" class="label">
              Conteúdo do pallet
            </label>
            <ul id="pallet-content-list" class="pallet-content-list">
              <li class="pallet-content-item" *ngFor="let skuGroup of relocateForm.controls.pallet.value?.skuGroups">
                <span class="sku">{{ skuGroup.sku }}</span>
                <span class="name">{{ skuGroup.name }}</span>
              </li>
            </ul>
          </div>
          <div class="cell min-cell" *ngIf="isSingleProduct">
            <label for="min" class="label">Min</label>
            <mat-form-field class="min">
              <input id="min" matInput formControlName="min" type="number" [min]="0">
            </mat-form-field>
          </div>

          <div class="cell max-cell" *ngIf="isSingleProduct">
            <label for="max" class="label">Max</label>
            <mat-form-field class="max">
              <input id="max" matInput formControlName="max" type="number" [min]="relocateForm.controls.min.value || 0">
            </mat-form-field>
          </div>
        </div>

        <app-sidenav-destination #destination
          (changed)="destinationDataChanged($event)"
          [groundType]="isSingleProduct ? 'PICKING' : 'PICKING_MISCELLANEOUS'"
          [products]="data?.products">
        </app-sidenav-destination>

<!--        <mat-tab-group>-->
<!--          <mat-tab label="Pallets específicos">-->
<!--            <mat-form-field class="pallets">-->
<!--              <mat-label>Selecione os pallets desejados</mat-label>-->
<!--              <mat-select multiple formControlName="pallets">-->
<!--                <mat-option *ngFor="let pallet of palletsOptions"-->
<!--                            [value]="pallet">-->
<!--                  {{ 'Posição: ' + handlePosition(pallet.x, pallet.y) + ', quantidade: ' + handleQuantity(pallet.skuGroups)}}-->
<!--                </mat-option>-->
<!--              </mat-select>-->
<!--            </mat-form-field>-->
<!--          </mat-tab>-->
<!--          <mat-tab label="Quantidades">-->
<!--            <input placeholder="Digite a quantidade desejada" formControlName="quantity">-->
<!--          </mat-tab>-->
<!--        </mat-tab-group>-->
      </div>
    </form>

    <p class="error" *ngIf="selectOperatorError">Selecione um ou mais operadores para atribuir a tarefa.</p>
    <p class="error" *ngIf="noPickingSectorError">Não há setores do tipo SEPARAÇÃO cadastrados no sistema. Vá à tela de setup e cadastre!</p>
    <p class="error" *ngIf="noPalletsError">Não há pallets disponíveis com este produto.</p>
    <p class="error" *ngIf="minRequiredError">O valor mínimo é obrigatório e deve ser maior ou igual a zero.</p>
    <p class="error" *ngIf="maxRequiredError">O valor máximo é obrigatório e deve ser maior ou igual ao valor mínimo.</p>

    <app-operators-table 
                         [usersHighlighted]="usersHighlighted"
                         (usersHighlightedEvent)="setUsers($event)"
                         [openedStart]="drawer.openedStart"></app-operators-table>
  </div>

  <div class="footer">
    <button mat-stroked-button class="gray-2" (click)="close()">CANCELAR</button>
    <button mat-raised-button class="primary-1" (click)="submit()">OK</button>
  </div>
</div>
